import React from 'react';
export function NavBar() {
  return <nav style={{
    padding: '16px',
    borderBottom: '1px solid #eee'
  }} data-id="element-1270">
      <a href="/" style={{
      marginRight: '20px'
    }} data-id="element-1271">
        Home
      </a>
      <a href="/blog" style={{
      marginRight: '20px'
    }} data-id="element-1272">
        Blog
      </a>
      <a href="/about" style={{
      marginRight: '20px'
    }} data-id="element-1273">
        About
      </a>
      <a href="/faq" style={{
      marginRight: '20px'
    }} data-id="element-1274">
        FAQ
      </a>
    </nav>;
}